import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

export default function FaqSection() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-32 bg-anthracite/40 border-y border-white/5">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <div className="text-center">
          <span className="font-accent text-xs uppercase tracking-[0.3em] text-teal-light">FAQ</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white leading-tight">
            Domande frequenti
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-b border-white/10">
              <AccordionTrigger className="text-left text-white hover:text-teal-light hover:no-underline py-5 text-base">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 leading-relaxed text-sm pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
